import ZkSystemDictionary from './src/main'
ZkSystemDictionary.install = function (Vue) {
  Vue.component(ZkSystemDictionary.name, ZkSystemDictionary)
}
export default ZkSystemDictionary



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/systemDictionary/index.js